import { getSluggedProps } from './getSluggedProps.js';
/**
 * Takes an object with an optional `spacingSizes` property and transforms it into the ThemePropertiesSpacing object type.
 * @param {SpacingProperties} spacing - An object with an optional `spacingSizes` property.
 * @returns {ThemePropertiesSpacing} An object with an optional `sizes` property of type `SpacingSizes`.
 */
export function getSpacingOptions(spacing) {
    if (spacing === null || spacing === void 0 ? void 0 : spacing.spacingSizes) {
        return {
            sizes: getSluggedProps(spacing.spacingSizes, 'size'),
        };
    }
    return {};
}
